















import { Vue } from 'vue-property-decorator';
import HeaderSection from '@/common/components/HeaderSection';
import OsaFooter from '@/common/components/OsaFooter';
import { TokenHelper } from './common/utils/TokenHelper';
import { LoginStatesOptions } from './models';

export default Vue.extend({
  name: 'App',
  components: {
    HeaderSection,
    OsaFooter,
  },
  data() {
    return {
      login: 'Login' as string,
      token: '' as string,
      domContext: {} as HTMLElement | null,
      url: '' as string,
    };
  },
  created() {
    this.domContext = document.getElementById('app');
    if (this.domContext !== null) {
      this.token = this.domContext.getAttribute('data-token') as string;
      this.url = this.domContext.getAttribute('data-url') as string;
      sessionStorage.setItem('url', this.url);
      if (this.url !== '') {
        if (this.url == '/welcome') {
          TokenHelper.saveToken(this.token, this.url);
          this.$store.dispatch('user/setUser', TokenHelper.getUserInformation());
          this.authOsaId();
        } else {
          const parameters = this.url.split('/');
          this.refreshPage(this.url, parameters[parameters.length - 1]);
        }
      } else {
        this.goToLogin(this.url);
      }
    }
  },
  methods: {
    authOsaId() {
      const dataLoginState = this.$store.getters['user/getState'];
      if (dataLoginState == LoginStatesOptions.Success) {
        this.goToWelcome(this.$store.getters['user/getDebtorNumber']);
      } else if (dataLoginState == LoginStatesOptions.Locked) {
        this.goToLocked();
      } else {
        TokenHelper.deleteToken();
        sessionStorage.setItem('auth', 'false');
        this.goToLogin('/');
      }
    },
    refreshPage(url: string, parameters: string) {
      this.$router.push({
        path: url,
        params: {
          id: parameters,
        },
      });
    },
    goToLogin(url: string) {
      this.$router.push({
        name: 'Index',
        params: {
          id: url,
        },
      });
    },
    goToWelcome(debtorNumber: string) {
      this.$router.push({
        name: 'Welcome',
        params: {
          id: debtorNumber,
        },
      });
    },
    goToLocked() {
      this.$router.push({
        name: 'Locked',
        params: {},
      });
    },
  },
});
